import { render } from "./producer-delete.vue?vue&type=template&id=6500cab9"
import script from "./producer-delete.vue?vue&type=script&lang=js"
export * from "./producer-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__